import { render, staticRenderFns } from "./PersonalityDefault.vue?vue&type=template&id=630b22ac&scoped=true&"
import script from "./PersonalityDefault.vue?vue&type=script&lang=js&"
export * from "./PersonalityDefault.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityDefault.vue?vue&type=style&index=0&id=630b22ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b22ac",
  null
  
)

export default component.exports